export const TRIVIA_QUESTION_MAX_CHARS = 140;
export const TRIVIA_CHOICE_MAX_CHARS = 48;
export const TRIVIA_MIN_CHOICES = 2;
export const TRIVIA_MAX_CHOICES = 6;
export const TRIVIA_MIN_TIMER_S = 5;
export const TRIVIA_MAX_TIMER_S = 300;
export const TRIVIA_DEFAULT_TIMER_MS = 30_000;
export const TRIVIA_TIMER_PRESETS_S = [15, 20, 30, 45, 60] as const;
export const TRIVIA_HIDE_ANSWERS_KEY = 'trivia-hide-answers';

export const TRIVIA_CHOICE_COLORS = [
  '#3DA9FF',
  '#F5B942',
  '#B57BFF',
  '#FF5C9A',
  '#2EC4B6',
  '#FF8A3D',
] as const;

export const TRIVIA_CHOICE_LETTERS = ['A', 'B', 'C', 'D', 'E', 'F'] as const;

export function choiceLetter(index: number) {
  return TRIVIA_CHOICE_LETTERS[index] ?? String(index + 1);
}

export function choiceColor(index: number) {
  return TRIVIA_CHOICE_COLORS[index % TRIVIA_CHOICE_COLORS.length];
}

export function formatCountdown(ms: number) {
  const total = Math.max(0, Math.ceil(ms / 1000));
  const m = Math.floor(total / 60);
  const s = total % 60;
  return `${m}:${s.toString().padStart(2, '0')}`;
}
